<ul class="layout-menu">
  @for (item of model; track $index) {
    <ng-container>
      @if (!item.separator) {
        <li app-menuitem [item]="item" [index]="$index" [root]="true"></li>
      }
      @else {
        <li class="menu-separator"></li>
      }
    </ng-container>
  }
</ul>
